import { render } from "./staff_bankcard.vue?vue&type=template&id=e2de5516&scoped=true"
import script from "./staff_bankcard.vue?vue&type=script&lang=js"
export * from "./staff_bankcard.vue?vue&type=script&lang=js"

import "./staff_bankcard.vue?vue&type=style&index=0&id=e2de5516&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2de5516"]])

export default __exports__